import { deleteCookie, getCookie, setCookie } from "./generalUtilities";

//const WIZARD_PROGRESS_KEY = "wizard_progress";
const getWizardKey = (userID: string) => `wizard_progress_${userID}`;

export interface WizardProgress {
  lastCompletedStep: number;
  terms_accepted: boolean;
}

const BENEFICIARIES_STEP = 2;
const INTRODUCTION_STEP = 1;

export const wizardProgress = {
  getProgress: (userID: string): WizardProgress => {
    try {
      //const stored = getCookie(WIZARD_PROGRESS_KEY);
      const stored = getCookie(getWizardKey(userID));
      if (!stored) {
        return {
          lastCompletedStep: 0,
          terms_accepted: false,
        };
      }

      const parsed = JSON.parse(stored);
      return {
        lastCompletedStep: parsed.lastCompletedStep || 0,
        terms_accepted: parsed.terms_accepted || false,
      };
    } catch {
      return {
        lastCompletedStep: 0,
        terms_accepted: false,
      };
    }
  },

  saveStepProgress: (stepNumber: number, userID: string): void => {
    try {
      const existingProgress = wizardProgress.getProgress(userID);
      const updatedProgress: WizardProgress = {
        lastCompletedStep: Math.max(
          stepNumber,
          existingProgress.lastCompletedStep,
        ),

        terms_accepted: existingProgress.terms_accepted,
      };

      setCookie(getWizardKey(userID), JSON.stringify(updatedProgress), 30);
    } catch {
      // Handle error if needed, e.g. log to an error tracking service
    }
  },
  getStartingStep: (isModal: boolean = false, userID: string): number => {
    const progress = wizardProgress.getProgress(userID);

    if (!progress.terms_accepted) {
      return isModal ? BENEFICIARIES_STEP : INTRODUCTION_STEP;
    }

    const nextStep = Math.max(2, progress.lastCompletedStep + 1);
    return Math.min(nextStep, 6);
  },

  saveTermsAcceptance: (accepted: boolean, userID: string): void => {
    try {
      const existingProgress = wizardProgress.getProgress(userID);
      const updatedProgress: WizardProgress = {
        ...existingProgress,
        terms_accepted: accepted,
      };

      setCookie(getWizardKey(userID), JSON.stringify(updatedProgress), 30);
    } catch {
      // Handle error if needed, e.g. log to an error tracking service
    }
  },

  isTermsAccepted: (userID: string): boolean => {
    const progress = wizardProgress.getProgress(userID);
    return progress.terms_accepted;
  },

  resetProgress: (userID: string): void => {
    try {
      const existingProgress = wizardProgress.getProgress(userID);

      if (existingProgress.lastCompletedStep >= BENEFICIARIES_STEP) {
        const updatedProgress: WizardProgress = {
          ...existingProgress,
          lastCompletedStep: INTRODUCTION_STEP,
        };
        setCookie(getWizardKey(userID), JSON.stringify(updatedProgress), 30);
      }
    } catch {
      // Handle error if needed, e.g. log to an error tracking service
    }
  },

  clearProgress: (userID: string): void => {
    try {
      deleteCookie(getWizardKey(userID));
    } catch {
      // Handle error if needed, e.g. log to an error tracking service
    }
  },
};
